"use client";

import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/src/components/shadcn/ui/badge";
import { Separator } from "@/src/components/shadcn/ui/separator";
import type { ReferralMatchMetadata } from "@/src/models/task-approval";
export function ReferralMatchEvidence(t0) {
  const $ = _c(50);
  const {
    metadata
  } = t0;
  if (!metadata) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-sm text-muted-foreground">No match details available.</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const {
    evidence,
    evaluation
  } = metadata;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== evaluation.matchedIndex || $[2] !== evidence.openReferrals || $[3] !== metadata.instruction) {
    let t5;
    if ($[8] !== evaluation.matchedIndex) {
      t5 = r => r.index === evaluation.matchedIndex;
      $[8] = evaluation.matchedIndex;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const matchedReferral = evidence.openReferrals.find(t5);
    t1 = "flex flex-col gap-4 text-sm";
    if ($[10] !== metadata.instruction) {
      t2 = metadata.instruction && <p className="text-muted-foreground">{metadata.instruction}</p>;
      $[10] = metadata.instruction;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Separator />;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t4 = matchedReferral && <div className="flex flex-col gap-1.5"><p className="font-semibold">Matched Referral</p><div className="pl-3 flex flex-col gap-1 text-muted-foreground">{matchedReferral.specialty && <p><span className="text-foreground font-medium">Specialty:</span> {matchedReferral.specialty}</p>}{matchedReferral.performerName && <p><span className="text-foreground font-medium">Referred to:</span> {matchedReferral.performerName}</p>}{matchedReferral.performerAddress && <p><span className="text-foreground font-medium">Address:</span> {matchedReferral.performerAddress}</p>}{matchedReferral.reasonText && <p><span className="text-foreground font-medium">Reason:</span> {matchedReferral.reasonText}</p>}{matchedReferral.icdCodes.length > 0 && <div className="flex items-center gap-2 flex-wrap"><span className="text-foreground font-medium">ICD-10:</span>{matchedReferral.icdCodes.map(_temp)}</div>}{matchedReferral.startDate && <p><span className="text-foreground font-medium">Referral start:</span>{" "}{new Date(matchedReferral.startDate).toLocaleDateString()}</p>}{matchedReferral.endDate && <p><span className="text-foreground font-medium">Referral end:</span>{" "}{new Date(matchedReferral.endDate).toLocaleDateString()}</p>}</div></div>;
    $[1] = evaluation.matchedIndex;
    $[2] = evidence.openReferrals;
    $[3] = metadata.instruction;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="font-semibold">Document</p>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== evidence.progressNote.clinicName) {
    t7 = evidence.progressNote.clinicName && <p><span className="text-foreground font-medium">Clinic:</span> {evidence.progressNote.clinicName}</p>;
    $[15] = evidence.progressNote.clinicName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== evidence.progressNote.clinicAddress) {
    t8 = evidence.progressNote.clinicAddress && <p><span className="text-foreground font-medium">Clinic address:</span> {evidence.progressNote.clinicAddress}</p>;
    $[17] = evidence.progressNote.clinicAddress;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== evidence.progressNote.providerName) {
    t9 = evidence.progressNote.providerName && <p><span className="text-foreground font-medium">Provider:</span> {evidence.progressNote.providerName}</p>;
    $[19] = evidence.progressNote.providerName;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== evidence.progressNote.specialtyFolder) {
    t10 = evidence.progressNote.specialtyFolder && <p><span className="text-foreground font-medium">Specialty:</span> {evidence.progressNote.specialtyFolder}</p>;
    $[21] = evidence.progressNote.specialtyFolder;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== evidence.progressNote.reasonForVisit) {
    t11 = evidence.progressNote.reasonForVisit && <p><span className="text-foreground font-medium">Reason:</span> {evidence.progressNote.reasonForVisit}</p>;
    $[23] = evidence.progressNote.reasonForVisit;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== evidence.progressNote.dateOfEvent) {
    t12 = evidence.progressNote.dateOfEvent && <p><span className="text-foreground font-medium">Date of service:</span> {evidence.progressNote.dateOfEvent}</p>;
    $[25] = evidence.progressNote.dateOfEvent;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== evidence.progressNote.diagnosisCodes) {
    t13 = evidence.progressNote.diagnosisCodes.length > 0 && <div className="flex items-center gap-2 flex-wrap"><span className="text-foreground font-medium">Diagnoses:</span>{evidence.progressNote.diagnosisCodes.map(_temp2)}</div>;
    $[27] = evidence.progressNote.diagnosisCodes;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t14 = <div className="flex flex-col gap-1.5">{t6}<div className="pl-3 flex flex-col gap-1 text-muted-foreground">{t7}{t8}{t9}{t10}{t11}{t12}{t13}</div></div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator />;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="font-semibold">Match Reasoning</p>;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== evaluation.reasoning) {
    t17 = evaluation.reasoning.map(_temp3);
    $[39] = evaluation.reasoning;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <div className="flex flex-col gap-1.5">{t16}<ul className="pl-3 flex flex-col gap-1 list-disc list-inside text-muted-foreground">{t17}</ul></div>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t1 || $[44] !== t14 || $[45] !== t18 || $[46] !== t2 || $[47] !== t3 || $[48] !== t4) {
    t19 = <div className={t1}>{t2}{t3}{t4}{t5}{t14}{t15}{t18}</div>;
    $[43] = t1;
    $[44] = t14;
    $[45] = t18;
    $[46] = t2;
    $[47] = t3;
    $[48] = t4;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
}
function _temp3(reason, i) {
  return <li key={i}>{reason}</li>;
}
function _temp2(code_0) {
  return <Badge key={code_0} variant="outline" className="text-xs">{code_0}</Badge>;
}
function _temp(code) {
  return <Badge key={code} variant="outline" className="text-xs">{code}</Badge>;
}